import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';


@Component({
  selector: 'app-product-categories-modal',
  templateUrl: './product-categories-modal.component.html',
  styleUrls: ['./product-categories-modal.component.scss']
})
export class ProductCategoriesModalComponent implements OnInit {

  public implantsData: any;
  public implantValue: any;
  public editOb: any;
  public editData: any;
  public implantName: any;
  public implantId: any;
  successMsg: any;
  public model = {
    implant_id: ''
  } ;
  public user = {
    name : '',
  };
  public editPermission = false;
  constructor(public dialogRef: MatDialogRef<ProductCategoriesModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.products_categories.edit'] == 1) {
        this.editPermission = true;
      }
    }
    this.masterService.getData('/implants/get').subscribe(res => {
      // @ts-ignore
      this.implantsData = res.data;
    });

    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;
      const productCat = 'ProductCategories';
      this.masterService.getRecordById(id, enc_id, '/product_categories/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
        if (this.editData.edit.implant_id) {
          // tslint:disable-next-line:prefer-const
          let editImplantId = this.editData.edit.implant_id;
          this.implantName = this.editData.implant_list.filter(implant => implant.id === editImplantId);
          this.implantId = this.editData.edit.implant_id;
          this.implantName = this.implantName[0].name;

        } else {
          this.implantName = '';
        }

      });
    }
  }

  submitForm(data) {
    if (this.editData) {
      this.implantId = this.implantId ? this.implantId : '';
      data.implant_id = this.implantId;

      // tslint:disable-next-line:variable-name no-shadowed-variable max-line-length
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/product_categories/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });
    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data,  { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/product_categories/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }


    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
